import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import Dropdown from 'react-bootstrap/cjs/Dropdown'

import getMugshotSrc from '../../../utils/getMugshotSrc'
import openChatModal from '../../chat/openChatModal'
import Icon from '../../../components/Icon'
import GeneralInfoWithThumbnail from '../../../components/GeneralInfoWithThumbnail'
import openBusinessCard from '../../profile/openBusinessCard'
import { GoodiebagType } from '../../goodiebag/types'
import { _ } from '../../../utils/localization'
import useToggleBookmark from '../../goodiebag/useToggleBookmark'
import { User } from '../../auth/types'
import AttendeeCallStatus from '../../entervideocall/AttendeeCallStatus'
import { VirtualAttendee } from '../../../types/swagger'
import formatJobInfo from '../../../utils/formatJobInfo'
import useSlug from '../../../hooks/useSlug'
import { currentUserSelector } from '../../auth/authSlice'

const S = {
    AttendeeItem: styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 46px;
    `,
    MoreOptionText: styled.span`
        display: inline-block;
        padding-left: 10px;
        padding-bottom: 10px;
    `,
    DropDownToggle: styled(Dropdown.Toggle)`
        margin: 0 5px;
        padding: 0 3px 2px 3px;
        background-color: transparent;
        border: none;
        border-radius: 0;
        outline: none;
        box-shadow: none!important;
        &::after {
            display: none;
        }
        &:hover, &:focus, &:active {
            background-color: transparent;
            box-shadow: none!important;
        }
        &[aria-expanded="true"] {
            background-color: green!important;
            span > svg > path {
                fill: white!important;
            }
        }
    `,
    Actions: styled.div`
        display: flex;
        margin-left: 5px;
    `,
}

const MoreOptionDropDown = ({ attendee }: {attendee: VirtualAttendee}) => {
    const eventSlug = useSlug('eventSlug')
    const dispatch = useDispatch()
    const { toggleBookmark, bookmarkIcon, isBookmarked } = useToggleBookmark({
        id: attendee.id,
        type: GoodiebagType.Attendee,
    })
    const showBusinessCard = () => dispatch(openBusinessCard(attendee as User))
    return (
        <Dropdown>
            <S.DropDownToggle id="dropdown-basic" variant="success">
                <Icon icon="dotsVertical" color="black" size={22} />
            </S.DropDownToggle>

            <Dropdown.Menu>
                <Dropdown.Item>
                    <Icon icon="cardAccountDetailsOutline" color="black" />
                    <S.MoreOptionText onClick={showBusinessCard}>
                        {_('networking.attendee_list.open_business_card')}
                    </S.MoreOptionText>
                </Dropdown.Item>
                <Dropdown.Item onClick={() => dispatch(openChatModal(eventSlug, attendee.id))}>
                    <Icon icon="forum" color="black" />
                    <S.MoreOptionText>{_('networking.attendee_list.open_chat')}</S.MoreOptionText>
                </Dropdown.Item>
                <Dropdown.Item onClick={toggleBookmark}>
                    <Icon icon={bookmarkIcon} color="black" isActive={isBookmarked} />
                    <S.MoreOptionText>{_('networking.attendee_list.bookmark')}</S.MoreOptionText>
                </Dropdown.Item>
                {/* We will add Schedule a meeting later */}
                {/* <Dropdown.Item> */}
                {/*    <Icon icon="calendarClock" color="black"/> */}
                {/*    <S.MoreOptionText>Schedule a meeting</S.MoreOptionText> */}
                {/* </Dropdown.Item> */}
            </Dropdown.Menu>
        </Dropdown>
    )
}

const AttendeeListItem = (
    { attendee, hideActions } : { attendee: VirtualAttendee, hideActions?: boolean }
) => {
    const dispatch = useDispatch()
    const currentUser = useSelector(currentUserSelector())
    const description = formatJobInfo(attendee.jobtitle, attendee.company)
    const showBusinessCard = () => dispatch(openBusinessCard(attendee as User))
    return (
        <S.AttendeeItem>
            <GeneralInfoWithThumbnail
                image={getMugshotSrc(attendee)}
                onClick={showBusinessCard}
                name={`${attendee.first_name} ${attendee.last_name}`}
                description={description}
                noBorder
                size="sm"
                badge={attendee.is_online ? 'success' : 'danger'}
            >
                {!hideActions && (
                    <S.Actions>
                        <AttendeeCallStatus
                            attendee={attendee}
                            config={{ requestInPopover: true, adminId: currentUser.id }}
                        />
                        <MoreOptionDropDown attendee={attendee} />
                    </S.Actions>
                )}
            </GeneralInfoWithThumbnail>
        </S.AttendeeItem>

    )
}

export default AttendeeListItem
